// extracted by mini-css-extract-plugin
module.exports = {"emailExtensions":"styles_emailExtensions__6EloT"};